import { Table, TableBody, TableHead, TableRow } from '@mui/material';
import { forwardRef } from 'react';
import { TableComponents, TableVirtuoso } from 'react-virtuoso';
import { SalesOpportunityConversionByCategory } from '../../sales-opportunity/salesOpportunity.types';
import SalesOpportunityCategoryItem from './SalesOpportunityListItem';

interface SalesOpportunityCategoryListProps {
  list: SalesOpportunityConversionByCategory[];
  loadMoreRows: () => void;
  listScrollParent: HTMLElement;
}

const components: TableComponents<SalesOpportunityConversionByCategory> = {
  Table: (props) => <Table {...props} size="small" style={{ borderCollapse: 'separate' }} />,
  TableHead: forwardRef((props, ref) => <TableHead {...props} ref={ref} />),
  TableRow,
  TableBody: forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
};

const SalesOpportunityCategoryList = ({
  list,
  loadMoreRows,
  listScrollParent,
}: SalesOpportunityCategoryListProps) => (
  <TableVirtuoso
    data={list}
    customScrollParent={listScrollParent}
    endReached={loadMoreRows}
    style={{ height: '100%', width: '100%' }}
    components={components}
    itemContent={(_, item: SalesOpportunityConversionByCategory) => (
      <SalesOpportunityCategoryItem salesOpportunityCategory={item} />
    )}
  />
);

export default SalesOpportunityCategoryList;
